/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  app.Filters.FiltersView = app.View.extend({
    router: null,
    collection: null,
    events: {
      'change input[type=checkbox]': 'handleFilterInputChange',
      'change input[type=text]': 'handleFilterInputChange',
      'click #category a.js-category-filter': 'filtersApply',
      'click .but-apply': 'filtersApplyWithItems',
      'click .filter-drop': 'filtersDrop',
      'click .but-close': 'resetFilterSelection',
      'click input': 'checkIsLocked',
      'click .js-open-tooltip': 'openTooltipPopup',
      'click .popup_mobile_fill .js-popup-tooltip-close': 'closeTooltipPopup'
    },
    additionalOptions: [
      'router',
      'fader',
      'withEmptyFilter',
      'autoApplyFilters',
      'activeFilterPageModel',
      'mainWindow',
      'isRootFilterPage',
      'chosenFilters',
    ],
    fetchBoth: true,
    applyWithoutPopup: false,
    // становится true, когда фильтры запрошены при изменении инпута фильтра
    isChangingFilterInput: false,
    TIME_WAIT_TO_APPLY_FILTERS: 1000,
    /**
     * @inheritDoc
     */
    run: function () {
      this.debouncedFilterApply = _.debounce(this.filtersApply.bind(this), this.TIME_WAIT_TO_APPLY_FILTERS);
      this.listenTo(this.settlement, 'change:fast_delivery', this.onChangeSettlementFastDelivery);
      this.listenTo(Backbone, 'backbone-filter-apply', this.filtersApply);
      this.dropFiltersNameTemplate = app.helpers.TemplateHelper.getTemplate('#drop-filters-name-template');
      this.childViews = {};
      if (this.router instanceof Backbone.Router) {
        this.listenTo(Backbone, 'UrlParamsNotChanged', this.unlockFilters);
      }
      if (this.collection instanceof app.ItemPageableCollection) {
        this.listenTo(Backbone, 'parseFilterData', this.unlockFilters);
      }

      this.hasTiresAndWheelsFilter = $('.content-container-tires-and-wheels').length;
      this.element = $('#filter_block');
      this.categoryElement = $('#filter-category-list');
      // Создаем коллекцию для фильтров
      this.model = new app.Filters.Filters(null, {
        hasTiresAndWheelsFilter: this.hasTiresAndWheelsFilter,
        itemCollection: this.collection,
        isRootFilterPage: this.isRootFilterPage,
      });

      /* Создаем коллекцию и вью для выбранных фильтров */
      if (!this.chosenFilters) {
        this.chosenFilters = new app.ChosenFilters();
      }
      if ($('.chosen-filters-row').length) {
        var sectionsWithoutPopup = [
          'car_filter',
          'agg_has_discount',
          'agg_is_novelty',
          'agg_is_hit',
          'agg_is_wholesale',
          'agg_is_exclusive',
          'agg_is_markdown',
          'condition',
        ];
        this.childViews.chosenFiltersView = new app.ChosenFiltersRowView({
          filters: this.model,
          model: this.chosenFilters,
          collection: this.collection,
          activeFilterPageModel: this.activeFilterPageModel,
          filtersView: this,
          sectionsWithoutPopup: sectionsWithoutPopup,
          isRootFilterPage: this.isRootFilterPage,
        });
      }
      this.listenTo(this.collection, 'sync', this.updateFilterPageStatus);
      this.listenToOnce(this.chosenFilters, 'reset', this.updateFilterPageStatus);
      this.model.create({
        element: this.element,
        chosenFilters: this.chosenFilters,
      });
      $('#filter-category-list, #filter-category-item-all').on('click', 'a', function (e) {
          this.filtersApply(e);
      }.bind(this));
      this.renderDropFilterButton();
      this.setElement(this.element.parent());
      if (this.collection) {
        this.listenTo(Backbone, 'parseFilterData', this.renderFilters);
        if ($('#tree-filter-items-all').length) {
          this.childViews.headerView = new app.Filters.HeaderView({
            templateId: '#tree-filter-items-all',
            el: '#filter-category-item-all a',
            model: this.model.total,
            selectClass: 'selected',
          });
        }
        if ($('#search-results-header').length) {
          this.childViews.headerView = new app.Filters.HeaderView({
            templateId: '#search-results-header',
            el: '.search-results__head .js-search-result-header',
            model: this.model.total,
            collection: this.collection,
            chosenFilters: this.chosenFilters,
            filters: this.model,
            withCategoriesPopup: true,
          });
        }
        if ($('#category-pseudo-filter-template').length) {
          this.element.prepend(app.helpers.TemplateHelper.getTemplate('#category-pseudo-filter-template')());
          this.pseudoCategoryFilter = new app.Filters.CheckboxListView({
            el: this.$('#category-pseudo-filter'),
            object: {
              name: 'category-pseudo-filter',
              is_option_by_priority: true,
            },
            shouldApplySearchBar: false,
          });
          this.pseudoCategoryFilter.wrapFilters();
        }
        if (this.hasTiresAndWheelsFilter) {
          this.childViews.tiresAndWheelsFilter = new app.TiresAndWheelsFilterView({
            fader: this.fader,
            collection: this.collection,
            isParamsPopupFilters: app.features && app.features.is_params_popup_filters,
            hasNewLoader: this.autoApplyFilters,
            mainWindow: this.mainWindow,
          });
          this.listenTo(this.childViews.tiresAndWheelsFilter, 'fetchFilters', this._fetchFiltersOnly);
          this.listenTo(this.childViews.tiresAndWheelsFilter, 'fetchItems', this._restFiltersApply);
        }
      }
      if (this.chosenFilters) {
        this.listenTo(this.childViews.chosenFiltersView, 'drop-all', this.filtersDrop);
        this.listenTo(this.childViews.chosenFiltersView, 'update-filter', this.filtersApply);
        this.listenTo(this.childViews.chosenFiltersView, 'drop-one', this.filtersApply);
      }
      this.filterDropped = false;
      this.listenTo(this.childViews.chosenFiltersView, 'dropped-filter-on-mobile', this.setDroppedFlag);
      this.listenTo(Backbone, 'reset-filters', this.resetFilterSelection);
      if (!app.isMobile && !this.autoApplyFilters) {
        this._initializeApplyPopupView();
      }
      this.childViews.bottomTreeFilterView = new app.Filters.BottomTreeFilterView({
        el: '.js-bottom-tree-filters',
        collection: this.collection,
        applyFilterOnClick: this.filtersApply.bind(this),
      });
      this.listenTo(Backbone, 'all-filters-rendered', function () {
        this.childViews.bottomTreeFilterView.setModel(this.model.findWhere({ name: 'category' }));
      });
      this.prev = this._getPreviousFilterValue();
    },

    /**
     * Обновляет статус подфильтроворй страницы.
     * @param {Object} collection - коллекция фильтров/выбранных фильтров
     */
    updateFilterPageStatus: function (collection) {
      this.stopListening(this.chosenFilters, 'reset', this.updateFilterPageStatus);
      if (collection !== this.chosenFilters || this.fetchBoth) {
        if (this.collection) {
          this.collection.resetFilterPageFilters();
        }
        Backbone.trigger('update-filter-page-status');
        this.listenToOnce(this.chosenFilters, 'reset', this.updateFilterPageStatus);
      }
    },

    /**
     * Рендер кнопки сброса фильтров.
     */
    renderDropFilterButton: function () {
      // Рисуем кнопку только если есть активные фильтры, либо если кнопка была отрисована до изменения инпута фильтра.
      var hasActiveFilters = (this.collection && !_.includes(['null', '{}'], this.collection.filter))
        || (this.chosenFilters && this.chosenFilters.chosenFiltersQty);
      var hasDropButtonBeforeInputChange = this.filterDropButtonRendered && this.isChangingFilterInput;
      if ((hasActiveFilters && !this.isChangingFilterInput) || hasDropButtonBeforeInputChange) {
        this.element.append(this.dropFiltersNameTemplate());
      }
      this.isChangingFilterInput = false;
    },

    /**
     * Запрос фильтров при изменении информации о быстрой доставке в модели населенного пункта
     */
    onChangeSettlementFastDelivery: function () {
      var params = app.helpers.UrlHelper.getUrlParameters();
      this._fetchFiltersOnly(params);
    },
    /**
     * Устанавливает сброшенный флаг.
     */
    setDroppedFlag: function () {
      this.filterDropped = true;
    },
    /**
     * Рендер блока с фильтрами после применения фильтра.
     * Используется только для страниц каталога, поддерживающих REST.
     *
     * @param {boolean} simpleSortSelected - сортировать выбранные фильтры.
     */
    renderFilters: function (simpleSortSelected) {
      // очищаем коллекцию от старых моделей.
      _.each(this.model.models, function (model) {
        model.view.remove();
      });
      this.model.reset();
      // На мобильной версии блок с подфильтровыми страницами находится внутри
      // контейнера с фильтрами. Сохраняем его перед очисткой
      var hasFilterPageInside = app.isMobile && this.$('.top-filter-pages').length,
        filterPages,
        pseudoFilter,
        hasPseudoCategoryFilter = this.$('#category-pseudo-filter').length;
      if (hasFilterPageInside) {
        filterPages = this.$('.top-filter-pages').detach();
      }
      if (hasPseudoCategoryFilter) {
        pseudoFilter = this.$('#category-pseudo-filter').detach();
      }
      // очищаем блок с фильтрами.
      this.element.html('');
      if (hasFilterPageInside) {
        this.element.append(filterPages);
      }
      if (hasPseudoCategoryFilter) {
        this.element.prepend(pseudoFilter);
        this.pseudoCategoryFilter.wrapFilters();
      }
      this.categoryElement.html('');
      this.model.setData(app.filterData);
      this.model.create({
        element: this.element,
        chosenFilters: this.chosenFilters,
        simpleSortSelected: simpleSortSelected,
      });
      if (this.element.children().length === 0) {
        this.element.parent().addClass('has-no-filters');
        Backbone.trigger('toggle-filters-button', true);
      } else {
        Backbone.trigger('toggle-filters-button', false);
        this.element.parent().removeClass('has-no-filters');
        this.renderDropFilterButton();
      }
      if (this.prevScrollTop) {
        this.mainWindow.$el.scrollTop(this.prevScrollTop);
        this.prevScrollTop = 0;
      }
    },

    /**
     * Формирование строки get параметров для применения фильтров.
     * @param {object} get_par Объект с параметрами фильтров.
     * @returns {string} Строка get параметров.
     */
    createQueryString: function (get_par) {
      var request = [];
      for (var j in get_par) {
        if (j) {
          request.push(j + '=' + get_par[j]);
        }
      }
      return request.join('&');
    },
    /**
     * В случае применения фильтров через кнопку, убираем функцию в конец стэка,
     * чтобы успели примениться фильтры, которые были изменены. Нужно для мобильной версии.
     * Если уже ушел запрос на фильтры, ждем ответа перед применением.
     * @param event
     */
    filtersApplyWithItems: function (event) {
      var apply = _.bind(this.filtersApply, this);
      var delayTime = 100;
      if (this.isLocked) {
        this.listenToOnce(Backbone, 'parseFilterData', function () {
          apply(event);
        });
      } else {
        _.delay(apply, delayTime, event);
      }
    },
    /**
     * Удаляем значения, где нет выбранных фильтров.
     * @param obj
     *
     * @returns {*}
     */
    clearEmptyValues: function (obj) {
      _.each(obj, function (value, key) {
        if (_.isArray(value) && _.isEmpty(value)) {
          delete obj[key];
        }
      });
      return _.isEmpty(obj) ? null : obj;
    },
    /**
     * Подмерживаем значения примененных фильтров по шинам и дискам.
     * @param obj {Object} объект с фильтрами
     * @returns {Object} объект с фильтрами
     */
    mergeTiresAndWheelsFilters: function (obj) {
      var FILTER_BY_CAR_KEY = 'car_modification',
        TiresAndWheelFilterKeys = _.keys(this.childViews.tiresAndWheelsFilter.filterData).concat(FILTER_BY_CAR_KEY),
        tiresAndWheelsFilters = _.pick(
          this.collection.getFilter(),
          TiresAndWheelFilterKeys
        );
      return app.helpers.ObjectHelper.mergeDeep(obj, tiresAndWheelsFilters);
    },

    /**
     * Обработка изменения инпутов фильтров
     * @param {Event} event - событие изменения фильтров
     */
    handleFilterInputChange: function (event) {
      if (this.autoApplyFilters) {
        app.preloader.canRender = false;
        app.preloader.remove();
        this.applyWithoutPopup = true;
        this.collection.cancelAllPendingRequests();
        this.debouncedFilterApply();
        this.trigger('loader:show');
      } else {
        this.filterDropButtonRendered = this.$('.js-drop-filters-button').length > 0;
        this.isChangingFilterInput = true;
        this.filtersApply(event);
      }
    },

    /**
     * Выбор и применение фильтров.
     * @param {Event} event - событие изменения/применения фильтров
     * @param {Object} filterObj Передается при изменении фильтров из вьюхи выбранных фильтров
     * @param {boolean} forceApply Передается, если нужно сразу применить фильтры без попапа
     */
    filtersApply: function (event, filterObj, forceApply) {
      if (this.mainWindow) {
        this.prevScrollTop = this.mainWindow.getScrollTop();
      }
      if (event) {
        var target = $(event.currentTarget),
          applyButtonPressed = target.hasClass('but-apply'),
          categoryFilterChosen = target.hasClass('js-category-filter') && !target.hasClass('selected'),
          inputFilter = target.attr('id') && this.getInputFilterObj(target.attr('id')),
          name = target.data('name'),
          shouldReloadPage = name === 'condition';
        this.applyWithoutPopup = applyButtonPressed
          || categoryFilterChosen
          || forceApply;
        if (!applyButtonPressed && !this.filterPageFilterChangedByUser) {
          Backbone.trigger('filters-apply', 'applied');
          // для секционного фильтра
          if (target.data('section') && target.data('id')) {
            var filterId = target.data('section') + '-' + target.data('id');
            inputFilter = this.getInputFilterObj(filterId);
          }
          if (inputFilter || app.filterUrlParam) {
            this.filterPageFilterChangedByUser = this.collection.compareFilterObjects(inputFilter, app.filterUrlParam);
          }
        }
      }
      if (!this.autoApplyFilters) {
        app.preloader.render();
      }
      var obj = this.model.toQuery(),
        params = app.helpers.UrlHelper.getUrlParameters();
      if (!this.autoApplyFilters && (!event || event.type === 'change')) {
        this.lockFilters();
      }

      if (this.hasTiresAndWheelsFilter) {
        obj = this.mergeTiresAndWheelsFilters(obj);
      }
      this.prev = this._getPreviousFilterValue();
      this.filtersAreTheSame = this.collection.compareFilterObjects(obj, this.prev) && !app.isMobile;

      // если используются фильтры по категории, обрабатываем объект с фильтрами
      if (categoryFilterChosen && obj) {
        obj = this._updateFilterObjOnCategoryFilterChange(target, obj);
      }

      if (applyButtonPressed) {
        this.filterPageFilterChangedByUser = false;
      }

      // если передан объект с фильтрами для применения, применяем его
      if (filterObj) {
        obj = _.isEmpty(filterObj) ? null : filterObj;
      }
      if (this.withEmptyFilter && obj === null) {
        obj = {};
      }
      if (this.applyWithoutPopup && !this.withEmptyFilter) {
        obj = this.clearEmptyValues(obj);
      }
      if (this.isRootFilterPage) {
        obj = obj === null ? {} : obj;
        _.merge(obj, app.filterUrlParam);
      }
      params.f = JSON.stringify(obj);
      delete(params.page);
      if (this.router) {
        if (!this.filterDropped) {
          if (!this.applyWithoutPopup) {
            this._fetchFiltersOnly(params);
            return;
          }
          Backbone.trigger('change-category-wrapper');
        }
        this.trigger('filter-view:hide-popup');
        // shouldReloadPage true только если сбрасываем ПФС без фильтров.
        this._restFiltersApply(params, shouldReloadPage);
        // если фильтры уже отрендерились, сортируем выбранные фильтра после подтверждения применения фильтра
        if (applyButtonPressed && !shouldReloadPage) {
          this.renderFilters(true);
        }
        this.filterDropped = false;
        return;
      }
      this.filterDropped = false;
      this._defaultFiltersApply(params);
    },
    /**
     * Получаем объект с фильтром к которому относится инпут
     * @param {String} id
     * @returns {Object}
     */
    getInputFilterObj: function (id) {
      var key = id.split('-'),
        obj = {};
      obj[key[0]] = [key[1]];
      return obj;
    },
    /**
     * Добавляем в объект с фильтрами фильтры ПФС, если условиям соответствуют
     * @param {Object} merged
     */
    updateFilterObjOnFilterPage: function (merged) {
      // если мы на подфильтровой странице, добавляем фильтр к остальным фильтрам
      if (app.baseFilterPageUrl && app.filterUrlParam) {
        merged = app.helpers.ObjectHelper.mergeDeep(merged, app.filterUrlParam);
      }
      // если в примененных фильтрах есть фильтры подфильтровой страницы, добавляем их к объекту
      if (this.collection && this.collection.filterPagesApplied.length) {
        this.collection.filterPagesApplied.forEach(function (page) {
          merged = app.helpers.ObjectHelper.mergeDeep(merged, page.filter);
        });
      }
      return merged;
    },
    /**
     * Метод обрабатывает применение фильтров по категории.
     * @param {jQuery} target Элемент-триггер фильтрации.
     * @param {Object} obj Объект с фильтрами для применения.
     * @returns {Object} Обработанный объект с фильтрами для применения.
     * @private
     */
    _updateFilterObjOnCategoryFilterChange: function (target, obj) {
      var categoryFilter,
       id = String(target.data('id')),
       level = target.data('level');
      if (_.isUndefined(level)
        || (id === 'all')
      ) {
        delete obj.category;
        obj = _.isEmpty(obj) ? null : obj;
      } else if (level.length === 0 && _.get(this.router, 'type') !== 'search') {
        obj = {'category': [id]};
      } else {
        categoryFilter = {
          'level': target.data('level'),
          'values': [target.data('id')],
        };
        if (this.prev) {
          this.prev.category = categoryFilter;
          obj = this.prev;
        } else {
          obj = {'category': categoryFilter};
        }
      }
      return obj;
    },
    /**
     * Проверяем, были ли выбраны фильтры до этого.
     * @returns {*}
     * @private
     */
    _getPreviousFilterValue: function () {
      var prev = null,
        filters = app.helpers.UrlHelper.getUrlParameter('f') || app.filterUrlParam;
      if (filters) {
        if (_.isString(filters)) {
          try {
            prev = JSON.parse(filters);
          } catch (e) {
          }
        } else {
          prev = filters;
        }
      }
      return prev;
    },
    /**
     * Применение фильтров без запроса моделей
     * @param data
     * @private
     */
    _fetchFiltersOnly: function (data) {
      this.fetchBoth = false;
      this.collection.setFilter(data.f);
      this.collection.fetch({ filters: true, items: false });
      this.router.trigger('change-filter');
    },

    /**
     * Применение фильтров с запросом моделей
     *
     * @param data
     * @param shouldReloadPage
     *
     * @private
     */
    _restFiltersApply: function (data, shouldReloadPage) {
      var rootUrl = null,
        routerParams;
      var isPfsPage = Boolean(app.baseFilterPageUrl && app.filterPageId);
      this.fetchBoth = true;
      var pfsFilterKey = _.isObject(app.filterUrlParam) && Object.keys(app.filterUrlParam)[0],
        filterObjHasFP = Boolean(this.model.data[pfsFilterKey]);
      var isFilteredPfs = isPfsPage
        && app.helpers.FiltersHelper.filterObjHasAppliedPFS(JSON.parse(data.f), app.filterUrlParam);
      if (isPfsPage && !this.filterPageFilterChangedByUser && filterObjHasFP) {
          rootUrl = app.baseFilterPageUrl;
        if (!shouldReloadPage && isFilteredPfs) {
          rootUrl = null;
        }
      }
      this.router.forceFetch = true;
      if (!this.filtersAreTheSame) {
        // если фильтры изменились, сбрасываем значение в коллекции, чтобы роутер отреагировал на них
        this.collection.setFilter({});
      }
      var currentPathName = app.helpers.UrlHelper.getPathname();
      // если снят фильтр связанный с ПФС, сбрасываем урл к базовому без перезагрузки
      var pfsFilterDropped = app.baseFilterPageUrl
        && app.baseFilterPageUrl.length < currentPathName.length
        && !app.filterPageId
        && !isFilteredPfs
        && !shouldReloadPage;
      if (pfsFilterDropped || this.model.hasConditionFilter) {
        var params = app.helpers.UrlHelper.getUrlParameters();
        var urlToNavigate = pfsFilterDropped ? '/' + app.baseFilterPageUrl + '/' : currentPathName;
        this.router.navigate('/', {
          trigger: false,
          replace: true,
          rootUrl: urlToNavigate,
        }, params);
        rootUrl = null;
      }
      routerParams = {
        f: data.f,
      };
      if (data.category) {
        routerParams.category = data.category;
      }
      if (data.rootUrl) {
        rootUrl = data.rootUrl;
      }
      this.router.navigate('/', {
        trigger: true,
        rootUrl: rootUrl,
      }, routerParams);
    },

    /**
     * Применение фильтров без rest, с перезагрузкой страницы
     * @param data
     * @private
     */
    _defaultFiltersApply: function (data) {
      app.helpers.RedirectHelper.locationAssign('?' + this.createQueryString(data));
    },

    /**
     * Сброс всех параметров фильтров.
     */
    filtersDrop: function () {
      var params = app.helpers.UrlHelper.getUrlParameters();
      delete(params.f);
      delete(params.page);
      var filterObj = {};
      if (this.isRootFilterPage) {
        _.extend(filterObj, app.filterUrlParam);
      } else if (!this.withEmptyFilter) {
        filterObj = null;
      }
      if (this.router) {
        var data = {
          f: JSON.stringify(filterObj),
        };
        // Если сброс на пфс, делаем переход на базовый юрл пфс.
        if (app.filterPageId) {
          data.rootUrl = app.baseFilterPageUrl;
        }
        this.trigger('filter-view:hide-popup');
        this.model.updateChosenFilters(this.chosenFilters);
        this._restFiltersApply(data, true);
        return;
      }

      this._defaultFiltersApply(params);
    },
    /**
     * Показывает или скрывает секцию фильтров
     * @param event
     */
    toggleSection: function (event) {
      this.$(event.currentTarget).toggleClass('active');
      app.EventBus.trigger('filter.section.toggle.view', event);
    },

    /**
     * Разрешает выбирать фильтры
     */
    unlockFilters: function () {
      this.isLocked = false;
      app.preloader.remove();
      this.trigger('loader:hide');
      app.preloader.canRender = true;
    },
    /**
     * Запрещает выбирать фильтры
     */
    lockFilters: function () {
      this.isLocked = true;
    },
    /**
     * Проверяет, можно ли выбирать фильтры
     * @param e
     * @returns {boolean|void}
     */
    checkIsLocked: function (e) {
      if (this.isLocked) {
        e.preventDefault();
        return false;
      }
    },

    /**
     * Собирает данные о примененном фильтре, чтобы правильно показать попап после пере-рендеринга.
     * @param {Event}   e   Событие элемента фильтра
     * @param {Object}  obj Объект с данными о фильтре
     */
    preparePopup: function (e, obj) {
      var target = $(e.currentTarget),
        uniqId = target.attr('id'),
        openerId = uniqId ? uniqId : obj.name,
        that = this,
        total = 0,
        filterSectionId = target.closest('.section-inside')[0].id;
      //если id элемента содержит дробное число, экранируем
      if (_.isString(openerId) && openerId.indexOf('.') > -1) {
        openerId = openerId.replace('.', '\\.');
      }
      if (!this.filterDropped) {
        this.listenToOnce(Backbone, 'parseFilterData', function () {
          total = that.model.filtered;
          if (that.filtersAreTheSame || that.applyWithoutPopup) {
            that.trigger('filter-view:hide-popup');
          } else {
            that.trigger('filter-view:show-popup', openerId, total, filterSectionId);
          }
        });
      }
    },

    /**
     * Сбрасывает значения фильтров на те, что были до начала выбора.
     * Скрывает попап с кнопкой применить.
     */
    resetFilterSelection: function () {
      this.trigger('filter-view:hide-popup');
      this.prev = this.prev ? this.prev : {};
      var currentFilters = this.collection.getFilter();
      var filtersAreTheSame = this.collection.compareFilterObjects(currentFilters, this.prev);
      if (!filtersAreTheSame) {
        this.filtersApply(true, this.prev);
      }
    },

    /**
     * Инициализация попапа с кнопкой "Применить"
     * @private
     */
    _initializeApplyPopupView: function () {
      this.childViews.filterApplyPopupView = new app.FilterApplyPopupView({
        el: '#filter-apply-popup',
        filtersView: this,
      });
      this.listenTo(
        this.childViews.filterApplyPopupView,
        'filter-apply-popup:apply',
        this.filtersApplyWithItems
      );
      this.listenTo(Backbone, 'filter-was-chosen', this.preparePopup);
    },

    /**
     * Открывает попап с тултипом атрибута фильтра.
     * @param {Event} e
     * @param {Event} e
     */
    openTooltipPopup: function (e) {
      e.stopPropagation();
      e.preventDefault();
      var opener = $(e.currentTarget);
      opener.find('.tooltip').removeClass('not_display');
      $('body').addClass('no-back-scroll');
    },

    /**
     * Закрывает попап.
     * @param {Event} e
     */
    closeTooltipPopup: function (e) {
      e.stopPropagation();
      $('body').removeClass('no-back-scroll');
      $(e.currentTarget).parent().addClass('not_display');
    }
  });
})(jQuery);

}.call(window));